module.exports = __webpack_public_path__ + "static/media/whybgtopside.e075d8e3.png";